var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu" },
    [
      _c(
        "el-row",
        { staticClass: "tac" },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-menu",
                {
                  staticClass: "el-menu-vertical-demo",
                  attrs: {
                    "default-active": _vm.menuIndex,
                    "background-color": "#4A4E51",
                    "text-color": "#fff",
                    "active-text-color": "#ffd04b",
                    "unique-opened": true,
                    "default-openeds": _vm.openedMenu
                  },
                  on: { open: _vm.handleOpen, close: _vm.handleClose }
                },
                [
                  _vm.computedPermission(["管理员", "任务导师", "问卷导师", ""])
                    ? _c(
                        "el-submenu",
                        { attrs: { index: "5" } },
                        [
                          _c("template", { slot: "title" }, [
                            _c("i", { staticClass: "el-icon-user" }),
                            _vm._v(" "),
                            _c("span", [_vm._v("我的任务")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-menu-item-group",
                            [
                              _c(
                                "el-menu-item",
                                {
                                  attrs: { index: "qwrwcx" },
                                  on: {
                                    click: function($event) {
                                      return _vm.goPage(
                                        "/manage/allQuery",
                                        "qwrwcx"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("全网任务查询")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-menu-item",
                                {
                                  attrs: { index: "wdrw" },
                                  on: {
                                    click: function($event) {
                                      return _vm.goPage(
                                        "/manage/myTask",
                                        "wdrw"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("我的任务")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-menu-item",
                                {
                                  attrs: { index: "wdxx" },
                                  on: {
                                    click: function($event) {
                                      return _vm.goPage(
                                        "/manage/myMessage",
                                        "wdxx"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("我的消息")]
                              ),
                              _vm._v(" "),
                              _vm.computedPermission(["任务导师"])
                                ? _c(
                                    "el-menu-item",
                                    {
                                      attrs: { index: "wdpf" },
                                      on: {
                                        click: function($event) {
                                          return _vm.goPage(
                                            "/manage/mySend",
                                            "wdpf"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("我的派发")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.computedPermission(["问卷导师"])
                    ? _c(
                        "el-submenu",
                        { attrs: { index: "4" } },
                        [
                          _c("template", { slot: "title" }, [
                            _c("i", { staticClass: "el-icon-house" }),
                            _vm._v(" "),
                            _c("span", [_vm._v("问卷调查")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-menu-item-group",
                            [
                              _c(
                                "el-menu-item",
                                {
                                  attrs: { index: "wdwj" },
                                  on: {
                                    click: function($event) {
                                      return _vm.goPage(
                                        "/manage/myQuestion",
                                        "wdwj"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("我的问卷")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-menu-item",
                                {
                                  attrs: { index: "cjwj" },
                                  on: {
                                    click: function($event) {
                                      return _vm.goPage(
                                        "/manage/createQuestion",
                                        "cjwj"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("创建问卷")]
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.computedPermission(["管理员"])
                    ? _c(
                        "el-submenu",
                        { attrs: { index: "3" } },
                        [
                          _c("template", { slot: "title" }, [
                            _c("i", { staticClass: "el-icon-setting" }),
                            _vm._v(" "),
                            _c("span", [_vm._v("后台管理")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-menu-item-group",
                            [
                              _c(
                                "el-menu-item",
                                {
                                  attrs: { index: "yhgl" },
                                  on: {
                                    click: function($event) {
                                      return _vm.goPage(
                                        "/manage/user?type=" + 7,
                                        "yhgl"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("用户列表")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-menu-item",
                                {
                                  attrs: { index: "glz" },
                                  on: {
                                    click: function($event) {
                                      return _vm.goPage(
                                        "/manage/manageGroup",
                                        "glz"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("管理组")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-menu-item",
                                {
                                  attrs: { index: "gggl" },
                                  on: {
                                    click: function($event) {
                                      return _vm.goPage(
                                        "/manage/announcement?type=" + 5,
                                        "gggl"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("导师任务管理")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-menu-item",
                                {
                                  attrs: { index: "wjgl" },
                                  on: {
                                    click: function($event) {
                                      return _vm.goPage(
                                        "/manage/questionManage?type=" + 11,
                                        "wjgl"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("问卷管理")]
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-773cd235", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-773cd235","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pc/components/menu.vue
// module id = null
// module chunks = 